import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuthContext } from '../context/auth';

export default function PrivateRoute({ children, ...rest }) {
  const { isAuthenticated } = useAuthContext();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
      }
    />
  );
}
